/**
 * Lazily-created Supabase client.
 *
 * Every module that touches Supabase guards on `isSupabaseConfigured()` first,
 * so the entire accounts/sync feature is inert — no throw, no network call —
 * whenever the env vars are unset. That's required for anonymous mode (most
 * learners, by design) and for CI builds on forked PRs, which never have
 * access to repo secrets.
 *
 * The SDK itself is imported dynamically, so it is a separate chunk that is only
 * downloaded when accounts are configured.
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

let clientPromise = null;

export function isSupabaseConfigured() {
  return Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
}

/** Resolves to the shared client, or null when accounts aren't configured. */
export function getSupabase() {
  if (!isSupabaseConfigured()) return Promise.resolve(null);
  if (!clientPromise) {
    clientPromise = import('@supabase/supabase-js').then(({ createClient }) =>
      createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true
        }
      })
    );
  }
  return clientPromise;
}
